// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnvironmentTwoToneSvg from "@fishx/icons-svg/es/asn/EnvironmentTwoTone";
import FishxIcon from '../components/FishxIcon';

var EnvironmentTwoTone = function EnvironmentTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentTwoToneSvg
  }));
};

EnvironmentTwoTone.displayName = 'EnvironmentTwoTone';
export default React.forwardRef(EnvironmentTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EnvironmentTwoTone.js
// module id = 2607
// module chunks = 0